import React from 'react'

import Spinwheel from '../.././common/Spinwheel';

function ExchangeRateModal({ formik, addLoader, modalId }) {
  

  return (
    <div className="modal fade" id={modalId} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-sm modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header border-0">
            <button type="button" className="btn-close block-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body block-user">
            <div className="col-lg-12" style={{ zIndex: "1" }}>
              <form action="" className='p-4' onSubmit={formik?.handleSubmit} >
                <div className='d-flex justify-content-start'>
                  <h2 style={{ textAlign: "left !important" }}>
                    Money changer
                  </h2>
                </div>
                <div className='d-flex justify-content-start'>  <label htmlFor="currency" className="form-label"> Currency</label></div>
                <input name="currency" id="currency" className="form-control border mb-2" placeholder='Enter' disabled={formik?.values?._id} value={formik?.values?.currency} onChange={formik?.handleChange} onBlur={formik?.handleBlur} />
                {formik?.touched?.currency && formik?.errors?.currency ? (<div className='req-error'>{formik?.errors?.currency}</div>) : null}

                <div className='d-flex justify-content-start'>  <label htmlFor="exchangeCurrency" className="form-label">Exchange currency</label></div>
                <input name="exchangeCurrency" id="exchangeCurrency" className="form-control border mb-2" placeholder='Enter' disabled={formik?.values?._id} value={formik?.values?.exchangeCurrency} onChange={formik?.handleChange} onBlur={formik?.handleBlur} />
                {formik?.touched?.exchangeCurrency && formik?.errors?.exchangeCurrency ? (<div className='req-error'>{formik?.errors?.exchangeCurrency}</div>) : null}

                <div className='d-flex justify-content-start'>  <label htmlFor="buyValue" className="form-label"> Buy value</label></div>
                <input name="buyValue" id="buyValue" className="form-control border mb-2" placeholder='Enter' value={formik?.values?.buyValue} onChange={formik?.handleChange} onBlur={formik?.handleBlur} />
                {formik?.touched?.buyValue && formik?.errors?.buyValue ? (<div className='req-error'>{formik?.errors?.buyValue}</div>) : null}
                
                <div className='d-flex justify-content-start'>  <label htmlFor="saleValue" className="form-label"> Sell value</label></div>
                <input name="saleValue" id="saleValue" className="form-control border mb-2" placeholder='Enter' value={formik?.values?.saleValue} onChange={formik?.handleChange} onBlur={formik?.handleBlur} />
                {formik?.touched?.saleValue && formik?.errors?.saleValue ? (<div className='req-error'>{formik?.errors?.saleValue}</div>) : null}

                <div className="modal-footer border-0 justify-content-center pt-4">
                  <button type="submit" className="btn-custom w-auto" disabled={addLoader} >{addLoader ? <Spinwheel sizeClass="spin-small" /> : "Submit"}</button>
                  <button type="button" className="btn-custom w-auto" data-bs-dismiss='modal' >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ExchangeRateModal